import type { PublicQueueStatus } from '@/lib/member/safeAssets';

export const PUBLIC_QUEUE_STATUS_LABELS: Record<PublicQueueStatus, string> = {
  smooth: '顺畅',
  busy: '稍忙',
  peak: '高峰排队中',
  degraded: '部分任务较慢',
  maintenance: '维护中',
};

export const PUBLIC_QUEUE_STATUS_DESCRIPTIONS: Record<PublicQueueStatus, string> = {
  smooth: '目前生成速度正常，任务会依序完成。',
  busy: '目前生成任务较多，可能需要比平常多等待一点时间。',
  peak: '目前处于生成高峰，图片与影片任务会依序完成。',
  degraded: '部分生成任务可能较慢，已完成的结果会自动出现在生成纪录。',
  maintenance: '部分生成能力维护中，请稍后再试。',
};
